import { sorted } from '../../helper.esm.js';
import Options from '../../Options.esm.js';
import MatchL33t$1 from './variants/matching/reverse.esm.js';
import MatchL33t from './variants/matching/l33t.esm.js';

class MatchDictionary {
  constructor() {
    this.l33t = new MatchL33t(this.defaultMatch);
    this.reverse = new MatchL33t$1(this.defaultMatch);
  }

  match({
    password
  }) {
    const matches = [...this.defaultMatch({
      password
    }), ...this.reverse.match({
      password
    }), ...this.l33t.match({
      password
    })];
    return sorted(matches);
  }

  defaultMatch({
    password
  }) {
    // rankedDictionaries variable is for unit testing purposes
    const matches = [];
    const passwordLength = password.length;
    const passwordLower = password.toLowerCase();
    Object.keys(Options.rankedDictionaries).forEach(dictionaryName => {
      const rankedDict = Options.rankedDictionaries[dictionaryName];

      for (let i = 0; i < passwordLength; i += 1) {
        for (let j = i; j < passwordLength; j += 1) {
          if (passwordLower.slice(i, +j + 1 || 9e9) in rankedDict) {
            const word = passwordLower.slice(i, +j + 1 || 9e9);
            const rank = rankedDict[word];
            matches.push({
              pattern: 'dictionary',
              i,
              j,
              token: password.slice(i, +j + 1 || 9e9),
              matchedWord: word,
              rank,
              dictionaryName: dictionaryName,
              reversed: false,
              l33t: false
            });
          }
        }
      }
    });
    return matches;
  }

}

export { MatchDictionary as default };
//# sourceMappingURL=matching.esm.js.map
